import { Link } from "@/lib/nav";

import Pill from "@buildpy/ui/pill";
import { sectionCardClass } from "@buildpy/ui/section-card";
import { cn } from "@/lib/utils";
import { withVia } from "@buildpy/core/modules/customer/intake-page";
import { AREA_BAND_LABEL, RESIDENCE_LABEL } from "@buildpy/core/modules/customer/types";
import { publicPortfolioDetailPath, type PublicPortfolioCard } from "@buildpy/core/modules/portfolio/public-view";
import PublicPhoto from "@/modules/portfolio/ui/public-photo";

interface Props {
  slug: string;
  cards: readonly PublicPortfolioCard[];
  // 공개 링크 code — 상세 주소에 `?via=` 로 싣는다(없으면 안 붙인다).
  via: string | null;
}

export const publicCaseTraits = (card: Pick<PublicPortfolioCard, "area_band" | "residence">): string =>
  [card.area_band ? AREA_BAND_LABEL[card.area_band] : null, card.residence ? RESIDENCE_LABEL[card.residence] : null]
    .filter((v): v is string => v !== null)
    .join(" · ");

// 공개 시공사례 사진 그리드 — 조직 목록(`/s/portfolio/{slug}`)과 공개 링크 A(`/s/p/{code}`)가 같이 쓴다.
const PublicCaseGrid = ({ slug, cards, via }: Props) => (
  <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="public-portfolio-list">
    {cards.map((card) => {
      const traits = publicCaseTraits(card);
      return (
        <li key={card.id}>
          <Link
            className={cn(sectionCardClass({ padding: "none" }), "group flex h-full flex-col overflow-hidden")}
            href={withVia(publicPortfolioDetailPath(slug, card.id), via)}>
            <PublicPhoto alt={card.title} className="aspect-[4/3] w-full" src={card.cover_src} />
            <div className="flex flex-1 flex-col gap-y-1.5 p-3">
              <h2 className="line-clamp-2 text-sm font-medium group-hover:underline">{card.title}</h2>
              {traits && <p className="text-xs text-muted-foreground">{traits}</p>}
              {card.summary && <p className="line-clamp-2 text-xs text-muted-foreground">{card.summary}</p>}
              {card.tags.length > 0 && (
                <p className="flex flex-wrap gap-1 pt-1">
                  {card.tags.map((tag) => (
                    <Pill key={tag}>#{tag}</Pill>
                  ))}
                </p>
              )}
            </div>
          </Link>
        </li>
      );
    })}
  </ul>
);

export default PublicCaseGrid;
